export const categories = [
  { id: "zongyi", name: "综艺", slug: "zongyi", icon: "ri-tv-line", description: "热门综艺节目精选合集" },
  { id: "dongman", name: "动漫", slug: "dongman", icon: "ri-movie-line", description: "最新动漫番剧推荐" },
  { id: "duanshipin", name: "短视频", slug: "duanshipin", icon: "ri-vidicon-line", description: "精彩短视频集锦" },
  { id: "gaoxiao", name: "搞笑创意", slug: "gaoxiao", icon: "ri-emotion-laugh-line", description: "搞笑创意视频大全" },
  { id: "mitao", name: "蜜桃视频", slug: "mitao", icon: "ri-heart-line", description: "甜蜜生活记录" },
  { id: "yingtao", name: "樱桃视频", slug: "yingtao", icon: "ri-star-line", description: "美食与探店之旅" },
  { id: "mogu", name: "蘑菇视频", slug: "mogu", icon: "ri-landscape-line", description: "旅行风光大片" },
  { id: "qiezi", name: "茄子视频", slug: "qiezi", icon: "ri-mic-line", description: "趣味配音与恶搞" },
];

export const videos = [
  {
    id: 1,
    title: "爆笑合集：猫咪搞笑瞬间大集锦，笑到停不下来",
    category: "gaoxiao",
    thumbnail: "https://readdy.ai/api/search-image?query=Cute%20funny%20cat%20compilation%20video%20thumbnail%20with%20bright%20playful%20vibrant%20colors%2C%20entertainment%20style%2C%20clean%20simple%20background%2C%20high%20quality&width=640&height=360&seq=video-thumb-01&orientation=landscape",
    duration: "05:32",
    views: "128.6万",
    date: "2026-07-28",
    description: "精选全网最搞笑的猫咪视频合集，从猫咪打架到猫咪犯傻，每一个瞬间都让你捧腹大笑。本合集收录了超过50个精选片段，保证让你笑出腹肌。",
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: "综艺精选：《欢乐喜剧人》最爆笑片段合集",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20comedy%20stage%20performance%20thumbnail%20with%20bright%20stage%20lights%2C%20entertainment%20vibrant%20atmosphere%2C%20clean%20background&width=640&height=360&seq=video-thumb-02&orientation=landscape",
    duration: "12:18",
    views: "256.3万",
    date: "2026-07-26",
    description: "《欢乐喜剧人》历届最精彩的小品和相声片段合集，汇集了沈腾、贾玲、岳云鹏等顶级喜剧人的经典表演。",
    featured: true,
    hot: true,
  },
  {
    id: 3,
    title: "2026年最值得期待的国产动漫大盘点",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20animation%20anime%20style%20thumbnail%20with%20vibrant%20colorful%20characters%2C%20dynamic%20composition%2C%20clean%20simple%20background%2C%20entertainment%20style&width=640&height=360&seq=video-thumb-03&orientation=landscape",
    duration: "08:45",
    views: "89.2万",
    date: "2026-07-25",
    description: "盘点2026年下半年最值得期待的国产动漫作品，包括《斗罗大陆》《完美世界》《凡人修仙传》等热门IP的最新动态。",
    featured: true,
    hot: false,
  },
  {
    id: 4,
    title: "创意短视频：10个让人惊叹的生活小妙招",
    category: "duanshipin",
    thumbnail: "https://readdy.ai/api/search-image?query=Creative%20life%20hacks%20DIY%20tips%20video%20thumbnail%2C%20bright%20clean%20kitchen%20setting%2C%20modern%20minimalist%2C%20entertainment%20vibrant%20style&width=640&height=360&seq=video-thumb-04&orientation=landscape",
    duration: "03:21",
    views: "342.7万",
    date: "2026-07-24",
    description: "10个超级实用的生活小妙招，每一个都能让你的日常生活变得更加轻松便捷，学会之后你会感谢自己的！",
    featured: false,
    hot: true,
  },
  {
    id: 5,
    title: "蜜桃视频：夏日海边度假vlog，治愈系日常",
    category: "mitao",
    thumbnail: "https://readdy.ai/api/search-image?query=Summer%20beach%20vacation%20vlog%20aesthetic%20thumbnail%2C%20warm%20sunset%20colors%2C%20happy%20vibe%2C%20clean%20simple%20background%2C%20lifestyle%20photography&width=640&height=360&seq=video-thumb-05&orientation=landscape",
    duration: "15:42",
    views: "67.8万",
    date: "2026-07-23",
    description: "跟着博主一起享受夏日海边的美好时光，阳光、沙滩、海浪，还有美食和欢笑，治愈你的每一天。",
    featured: false,
    hot: false,
  },
  {
    id: 6,
    title: "樱桃视频：成都美食探店，隐藏在小巷里的美味",
    category: "yingtao",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20street%20food%20Chengdu%20delicious%20cuisine%20thumbnail%2C%20warm%20inviting%20colors%2C%20food%20photography%20style%2C%20clean%20simple%20background&width=640&height=360&seq=video-thumb-06&orientation=landscape",
    duration: "10:15",
    views: "45.3万",
    date: "2026-07-22",
    description: "带你走进成都最地道的小巷子，发现那些只有本地人才知道的隐藏美食，从麻辣烫到甜水面，每一样都让人垂涎欲滴。",
    featured: false,
    hot: false,
  },
  {
    id: 7,
    title: "蘑菇视频：云南大理绝美风光大片",
    category: "mogu",
    thumbnail: "https://readdy.ai/api/search-image?query=Dali%20Yunnan%20beautiful%20landscape%20travel%20photography%20thumbnail%2C%20mountain%20lake%20scenery%2C%20bright%20natural%20colors%2C%20clean%20simple%20composition&width=640&height=360&seq=video-thumb-07&orientation=landscape",
    duration: "18:30",
    views: "93.5万",
    date: "2026-07-21",
    description: "云南大理的苍山洱海、古城风韵，用镜头记录下这片神奇土地最美的瞬间，每一帧都是壁纸级别的画面。",
    featured: true,
    hot: false,
  },
  {
    id: 8,
    title: "茄子视频：经典电影爆笑配音合集",
    category: "qiezi",
    thumbnail: "https://readdy.ai/api/search-image?query=Funny%20movie%20dubbing%20parody%20thumbnail%2C%20humorous%20entertainment%20vibrant%20style%2C%20clean%20simple%20background%2C%20comedy%20theme&width=640&height=360&seq=video-thumb-08&orientation=landscape",
    duration: "07:55",
    views: "178.4万",
    date: "2026-07-20",
    description: "经典电影片段配上搞笑方言配音，效果出奇地好！从《大话西游》到《功夫》，每一段都让你笑得停不下来。",
    featured: false,
    hot: true,
  },
  {
    id: 9,
    title: "最新综艺：《披荆斩棘的哥哥》精彩舞台纯享版",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20music%20variety%20show%20stage%20performance%20thumbnail%2C%20dramatic%20lighting%2C%20concert%20atmosphere%2C%20vibrant%20colors%2C%20clean%20background&width=640&height=360&seq=video-thumb-09&orientation=landscape",
    duration: "22:10",
    views: "412.6万",
    date: "2026-07-19",
    description: "《披荆斩棘的哥哥》最新一季的精彩舞台表演合集，每一位哥哥都拿出了看家本领，舞台效果炸裂。",
    featured: true,
    hot: true,
  },
  {
    id: 10,
    title: "治愈系动漫推荐：5部让你瞬间放松的番剧",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Healing%20relaxing%20anime%20style%20thumbnail%2C%20soft%20warm%20pastel%20colors%2C%20peaceful%20atmosphere%2C%20clean%20simple%20background%2C%20cozy%20vibes&width=640&height=360&seq=video-thumb-10&orientation=landscape",
    duration: "09:28",
    views: "56.9万",
    date: "2026-07-18",
    description: "工作学习压力大？这5部治愈系动漫绝对能让你放松下来，温暖的画风和舒缓的节奏，是最好的心灵解药。",
    featured: false,
    hot: false,
  },
  {
    id: 11,
    title: "搞笑创意：当你把日常物品拟人化会发生什么",
    category: "gaoxiao",
    thumbnail: "https://readdy.ai/api/search-image?query=Creative%20funny%20stop%20motion%20animation%20thumbnail%2C%20everyday%20objects%20with%20faces%2C%20humorous%20bright%20colors%2C%20clean%20simple%20background&width=640&height=360&seq=video-thumb-11&orientation=landscape",
    duration: "04:15",
    views: "201.3万",
    date: "2026-07-17",
    description: "创意达人将日常物品拟人化后的搞笑场景，脑洞大开的创意让人忍俊不禁，原来我们身边的物品也有自己的小剧场。",
    featured: false,
    hot: true,
  },
  {
    id: 12,
    title: "短视频：3分钟看完一部电影的最强解说",
    category: "duanshipin",
    thumbnail: "https://readdy.ai/api/search-image?query=Movie%20review%20fast%20recap%20video%20thumbnail%2C%20cinematic%20style%2C%20dramatic%20composition%2C%20entertainment%20vibrant%20colors%2C%20clean%20background&width=640&height=360&seq=video-thumb-12&orientation=landscape",
    duration: "03:05",
    views: "567.8万",
    date: "2026-07-16",
    description: "3分钟带你快速了解一部电影的全部精华，省时又过瘾！本期带来2026年暑期档最热门的大片解说。",
    featured: false,
    hot: true,
  },
];

export const faqs = [
  {
    question: "久久视频是免费的吗？",
    answer: "是的，久久视频平台上的所有内容都是免费在线观看的，无需注册或付费。我们致力于为用户提供最优质的免费视频内容服务。",
  },
  {
    question: "久久视频包含哪些类型的视频内容？",
    answer: "久久视频聚合了蜜桃视频、樱桃视频、蘑菇视频、茄子视频等多个平台的泛娱乐内容，涵盖综艺节目、动漫番剧、短视频、搞笑创意视频等多种类型，满足不同用户的观看需求。",
  },
  {
    question: "如何在久久视频上找到我想看的内容？",
    answer: "您可以通过首页的分类导航快速筛选感兴趣的视频类型，也可以使用搜索功能查找特定内容。我们还设有热门推荐和最新上线板块，帮助您发现更多精彩视频。",
  },
  {
    question: "久久视频支持移动端观看吗？",
    answer: "当然支持！久久视频网站完美适配手机、平板和电脑等多种设备，无论您使用什么设备，都能获得流畅的观看体验。",
  },
  {
    question: "久久视频的内容多久更新一次？",
    answer: "我们每天都会更新最新的视频内容，确保您总能看到新鲜有趣的视频。热门综艺和动漫会有定期更新，短视频和搞笑创意内容更是24小时不间断上新。",
  },
];

export const testimonials = [
  {
    name: "小明的日常",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20profile%20picture%2C%20young%20boy%20style%2C%20simple%20flat%20design%2C%20warm%20colors%2C%20clean%20background&width=80&height=80&seq=avatar-01&orientation=squarish",
    comment: "久久视频真的太棒了！每天下班回家第一件事就是打开久久视频刷一刷搞笑视频，压力瞬间就没了。推荐给所有需要放松的朋友！",
    rating: 5,
  },
  {
    name: "动漫迷小樱",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20girl%20avatar%20profile%20picture%2C%20anime%20style%2C%20simple%20flat%20design%2C%20warm%20pink%20colors%2C%20clean%20background&width=80&height=80&seq=avatar-02&orientation=squarish",
    comment: "作为一个动漫爱好者，久久视频的动漫频道简直是我的快乐源泉！资源丰富更新快，画质也很清晰，强烈推荐！",
    rating: 5,
  },
  {
    name: "旅行达人老张",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20cartoon%20man%20avatar%20profile%20picture%2C%20traveler%20style%2C%20flat%20design%2C%20warm%20earth%20colors%2C%20clean%20background&width=80&height=80&seq=avatar-03&orientation=squarish",
    comment: "蘑菇视频的旅行内容做得非常好，让我在家就能云游四海。大理那期视频我看了三遍，每一帧都美得像画一样。",
    rating: 5,
  },
  {
    name: "吃货小红",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20girl%20avatar%20profile%20picture%2C%20foodie%20style%2C%20simple%20flat%20design%2C%20warm%20orange%20colors%2C%20clean%20background&width=80&height=80&seq=avatar-04&orientation=squarish",
    comment: "樱桃视频的美食探店系列是我的下饭神器！每次看他们吃美食都馋得不行，已经跟着打卡了好几家店了。",
    rating: 4,
  },
];

export const stats = [
  { label: "视频总量", value: "50万+", icon: "ri-vidicon-line" },
  { label: "日活用户", value: "800万+", icon: "ri-user-line" },
  { label: "每日更新", value: "5000+", icon: "ri-refresh-line" },
  { label: "内容分类", value: "20+", icon: "ri-grid-line" },
];